<template>
  <b-modal
    v-model="isShow"
    ok-variant="outline-secondary"
    :ok-title="$t('button.close')"
    centered
    title="Sport 99"
    size="lg"
    :hide-footer="true"
    @hide="isShow = false"
  >
    <div>
      <b-row class="pb-1">
        <b-col md="6">
          {{ $t('field.invoice') }} : #{{ data.no }}
        </b-col>
        <b-col md="6">
          {{ $t('field.date') }} : {{ data.createdAt | formatDate }}
        </b-col>
        <b-col md="6">
          {{ $t('field.gameType') }} : {{ data.channelName }}
        </b-col>
        <b-col md="6">
          {{ $t('field.betAmount') }} :
          <span
            :class="{
              'text-wala': data.amount > 0,
              'text-meron': data.amount < 0,
            }"
          > {{ data.amount | currency(data.ccy) }}
          </span>
        </b-col>
        <b-col md="6" class="text-capitalize">
          {{ $t('field.odd') }} : {{ data.payout }}
        </b-col>
        <b-col md="6">
          {{ $t('field.winLoss') }} :

          <span
            :class="{
              'text-wala': data.winAmount > 0,
              'text-meron': data.winAmount < 0,
            }"
          >
            {{ data.winAmount | currency(data.ccy) }}
          </span>
        </b-col>
        <b-col md="6">
          {{ $t('field.payback') }} :
          <span
            :class="{
              'text-wala': data.paybackAmount > 0,
              'text-meron': data.paybackAmount < 0,
            }"
          >
            {{ data.paybackAmount | currency(data.ccy) }}
          </span>
        </b-col>
        <b-col
          md="6"
          class="text-uppercase"
        >
          {{ $t('field.username') }} : {{ data.username }}
        </b-col>
      </b-row>
      <n-table
        :fields="fields"
        :items="items"
        :busy="loading"
        :current-page="1"
      >
        <template #cell(bet)="{ item }">
          <div>
            {{ item.selected.betOption }}
            {{ item.selected.hdp }}
            <span class="text-danger">@</span>
            {{ item.selected.odds }}
          </div>
          <div>
            {{ item.selected.sportType }}
            {{ item.selected.marketType }}
            Live! {{ item.selected.liveScore }}
          </div>
          <div>
            {{ item.selected.match }}
          </div>
          <div>
            {{ item.selected.league }}
          </div>
          <div>
            {{ item.selected.kickoffTime | formatDate("DD-MM-YYYY") }}
          </div>
        </template>
        <template #cell(result)="{ item, index }">
          <BBadge
            v-if="index === 0 && data.matchResult"
            :variant="getVariant()"
          >
            {{ data.matchResult }}
          </BBadge>
          <template>
            <div :class="`text-capitalize text-${item.selected.status}`">
              {{ item.selected.status }}
            </div>
            <div>
              HT: {{ item.selected.htScore }}
            </div>
            <div>
              FT: {{ item.selected.ftScore }}
            </div>
          </template>
        </template>
      </n-table>
    </div>
  </b-modal>
</template>

<script>
import {
  BCol, BModal, BRow, BBadge,
} from 'bootstrap-vue'
import NTable from '@/components/NTable.vue'
import { camelizeKeys } from 'humps'
import tableFields from './tableFields'

export default {
  components: {
    BModal,
    NTable,
    BRow,
    BCol,
    BBadge,
  },
  data() {
    return {
      loading: false,
      items: [],
      data: {},
      isShow: false,
    }
  },
  methods: {
    show(data) {
      this.isShow = true
      this.items = []
      // eslint-disable-next-line no-restricted-syntax
      for (const item of data.detail) {
        const selected = item.selected ? camelizeKeys(JSON.parse(item.selected)) : {}
        const result = item.result ? camelizeKeys(JSON.parse(item.result)) : {}

        this.items.push({
          selected,
          result,
        })
      }
      this.data = { ...data }
    },
    hide() {
      this.isShow = false
      this.items = []
    },
    getVariant() {
      if (this.data.matchResult) {
        if (this.data.matchResult.toLowerCase() === 'win') {
          return 'success'
        }

        if (this.data.matchResult.toLowerCase() === 'lose') {
          return 'danger'
        }
      }

      return 'secondary'
    },
  },
  setup() {
    const fields = [...tableFields]

    return {
      fields,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
